import { ChevronRight, Pin } from 'lucide-react';

interface Props {
  /**
   * Number of pinned messages currently in the channel. The banner
   * is suppressed entirely when this is zero — no point pointing
   * the user at an empty list.
   */
  count: number;
  onClick?: () => void;
}

/**
 * Pinned-messages banner shown across the top of the message list.
 * Positioned absolutely so it overlays the list — its translucent
 * background + `backdrop-blur` then picks up the message content
 * scrolling underneath, matching PopshopRN's frosted-glass look.
 * Clicking the banner switches the detail pane to the pinned-only
 * list view.
 */
export function ChannelPinnedBanner({ count, onClick }: Props) {
  if (count <= 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      className="border-line/80 bg-surface-1/60 hover:bg-surface-1/70 absolute inset-x-0 top-0 z-10 flex items-center justify-between border-b px-4 py-2.5 text-left text-sm backdrop-blur-md transition"
    >
      <div className="text-content-1 flex items-center gap-2">
        <Pin className="text-brand-text h-4 w-4 rotate-45" aria-hidden />
        {count} Pinned Message{count === 1 ? '' : 's'}
      </div>
      <ChevronRight className="text-content-3 h-4 w-4" aria-hidden />
    </button>
  );
}
